export const ar = {
  siteConfig: {
    siteName: "سياسة الحماية",
    tagline: "من أجل بيئة رياضية آمنة",
    topBarBack: "العودة إلى الموقع الرئيسي",
    topBarLabel: "نموذج سياسة الحماية",
  },
  nav: {
    home: "الرئيسية",
    intro: "مقدمة",
    principles: "المبادئ",
    definitions: "التعريفات",
    reporting: "الإبلاغ",
    officer: "مسؤول الحماية",
    risks: "مجالات الخطر",
    recruitment: "التوظيف",
    conduct: "قواعد السلوك",
    training: "التدريب",
    downloads: "التنزيلات",
  },
  hero: {
    tag: "سياسة الحماية",
    title: "نموذج سياسة الحماية لألعاب القوى",
    subtitle: "ضمان بيئة آمنة وإيجابية لجميع المشاركين في الألعاب الرياضية",
  },
  intro: {
    title: "ما هي سياسة الحماية؟",
    mainText: "الاتحاد العضو مسؤول عن تعزيز الألعاب الرياضية وعن جعلها بيئةً آمنةً وسعيدةً وإيجابيةً للأطفال والبالغين لتنمية مواهبهم وتحقيق أهدافهم. فيجب أن تكون هذه التجارب مرحةً وممتعة.",
    description: "تحدِّد سياسة الحماية هذه مسؤوليات الاتحاد العضو والمؤسسة لضمان قدرة الأطفال والبالغين على المشاركة في الألعاب الرياضية بأمان. ويؤمن الاتحاد العضو والمؤسسة أن للجميع الحق في المشاركة في الرياضة دون خوف من التعرض لإساءة المعاملة أو التحرش أو الاستغلال، وسيتأكدان من حماية هذا الحق بالكامل.",
    additionalText: "قد تصدر إساءة المعاملة من الرجال أو النساء أو الأطفال. وهي تحدث في كل بقاع العالم وفي كل رياضة ومنظمة. ولا يمكن لمنطقة أن تعتبر نفسها مستثناةً أو حصينة من تأثيرها.",
    contextText: "تحدث إساءة المعاملة والتحرش والاستغلال عندما يكون هناك اختلال في توازن القوى بين الأفراد. وعندما يكون أحد الأفراد في موقع أقوى، فمن الممكن أن يستغل ذلك وقد تحدث إساءة المعاملة أو التحرش أو الاستغلال.",
  },
  principles: {
    title: "بيان التزام السياسة ومبادئها",
    statement: "يؤمن المؤسسة بضرورة معاملة كل فرد في الألعاب الرياضية باحترام وبشكلٍ يحفظ كرامته، وأن له الحق في المشاركة في الألعاب الرياضية دون التعرض لإساءة المعاملة أو التحرش أو الاستغلال.",
    items: [
      { title: "الاحترام والكرامة", text: "لكل شخص الحق في أن يُعامل باحترام وبشكلٍ يحفظ كرامته، وألا يكون عُرضة للتمييز سواء على أساس الجنس أو الهوية الجنسية أو الأصل أو العُمر أو الانتماء العرقي أو القدرات أو الميول الجنسية أو المعتقدات أو الانتماء الديني أو السياسي.", icon: "heart" },
      { title: "البيئة الآمنة", text: "لكل شخص الحق في المشاركة في الألعاب الرياضية، والتمتع بها وتطوير نفسه بشكل شخصي من خلالها في بيئة آمنة وشمولية خالية من كل أشكال إساءة المعاملة أو التحرش أو الاستغلال.", icon: "shield" },
      { title: "حق الإصغاء", text: "لكل شخص من الأطفال والبالغين على حد سواء، الحق في أن يُصغى إليه، خاصةً إذا كان يُعرب عن مخاوف بشأن صالحه أو صالح شخص آخر. يجب أن يعرف كل شخص إلى مَن عليه التوجه لطلب المساعدة.", icon: "ear" },
      { title: "المصلحة الفضلى", text: "كل شخص مسؤول عن رعاية الأطفال وحمايتهم وعن اتخاذ القرارات بما يخدم مصلحتهم الفضلى، لأن صالحهم أمر بالغ الأهمية.", icon: "users" },
    ],
    commitmentTitle: "تحقيقًا لما سبق، فإن المؤسسة:",
    commitmentEyebrow: "بيان الالتزام",
    pledgesLabel: "تعهدات",
    commitments: [
      "سيقر بمسؤولية أعضاء مجلس إدارته عن تنفيذ هذه السياسة وإنفاذها، وسيعيّن \"بطل حماية\" لدمج مبادئ هذه السياسة في جميع جوانب برامجه.",
      "سيكون لديه عضو معيّن من الموظفين أو المتطوعين يتحمل مسؤولية قيادة جهود الحماية، وسيُدعى \"مسؤول الحماية\".",
      "سيحرص على أن الجميع يعرفون أن هذا الموظف أو المتطوع المعيّن هو الشخص الذي يمكنهم اللجوء إليه إن ساورهم القلق.",
      "سيحرص على أن الجميع على دراية بحقوقهم والإجراءات التي ستُتبع في حالة إثارة أية مخاوف.",
      "سينفّذ هذه السياسة ويضع الإجراءات، بما في ذلك مدوّنات قواعد السلوك والقواعد والإجراءات التأديبية.",
      "سيقدم الدعم والإرشاد إلى أي شخص يحتاج إليهما عقب التصريح عن مخاوف أو التقدم بشكوى.",
      "سيُعلّم ويدرب جميع الموظفين والمتطوعين على كيفية التعامل مع المخاوف والشكاوى.",
      "سيتعامل مع جميع المخاوف والادعاءات والشكاوى بطريقة عادلة وشفافة وفعالة وفي الوقت المناسب.",
      "سيجري جميع التحقيقات وجلسات الاستماع بطريقةٍ تضمن مستوى ملائمًا من الاستقلالية.",
      "سيتعامل مع جميع المعلومات المتعلقة بالمخاوف أو الشكاوى أو الادعاءات بسرية وسيحفظها بشكل آمن.",
      "سيعيّن الأشخاص المناسبين في الأماكن المُناسبة، وسيجري عمليات التحقق من الخلفية.",
      "سيتعاون مع الهيئات المحلية والمنظمات غير الحكومية والمجموعات المجتمعية.",
    ],
  },
  definitions: {
    title: "تعريفات",
    intro: "فيما يلي وصف لإساءة المعاملة والتحرش والاستغلال. يمكن أن يرتكبها كل من الرجال والنساء، وغالبًا ما يحدث ذلك عندما يكون أحد الطرفين في مركز سلطة يتحكم من خلاله في مقدرات الآخر.",
    items: [
      { title: "إساءة المعاملة النفسية", text: "فعل غير مرغوب به، ويشمل ذلك ذمّ الشخص أو التقليل من شأنه أو نبذه أو حصره أو عزله أو الاعتداء عليه قولاً أو إهانته أو ترهيبه أو معاملته معاملة الأطفال أو أي سلوك آخر قد يقوِّض إحساس المرء بهويته أو كرامته أو قيمته.", color: "#E8792B" },
      { title: "الاعتداء الجسدي", text: "أي فعل مقصود أو غير مرغوب فيه، كالركل أو الضرب أو العض أو الحرق، يتسبب في الإصابة أو الأذى الجسدي. ويمكن أن يشمل ذلك الاستهلاك القسري للكحول أو ممارسات إعطاء المنشطات بشكل منهجي.", color: "#D35400" },
      { title: "الاعتداء الجنسي", text: "أي سلوك ذو طبيعة جنسية، سواء كان يعتمد على الاتصال الجسدي أو لا يعتمد عليه، لا تُمنح الموافقة على ممارسته، أو يستحيل منحها، أو يُجبر المُتعرض له عليه أو يتعرض للتلاعب لممارسته.", color: "#C0392B" },
      { title: "الاستمالة", text: "عملية تعتمد على أن يبني شخص ما علاقة مع طفل، ويشجعه على الثقة به كي يتمكن من التلاعب به واستغلاله لمصلحته الخاصة. وغالبًا ما تؤدي استمالة أسرة الرياضي وبطانته وأصدقائه إلى اعتقاد أن المستميل يُعتمَد عليه.", color: "#8E44AD" },
      { title: "التحرش", text: "سلوك غير مرغوب فيه أو غير مُرحب به يسيء إلى المُتحرَّش به أو يجعله يشعر بالإهانة أو الخوف. ويحدث تحرش أصحاب السُلطة عندما يستخدم شخص ما في مركز سُلطة سُلطته ليتحرش بشخص آخر.", color: "#2980B9" },
      { title: "الاستغلال", text: "أن يمارس شخص ما سيطرة على شخص آخر وممتلكاته من أجل مكاسبه الشخصية دون موافقة مستنيرة. قد تكون المكاسب الشخصية نفسيةً أو متعلقةً بالسمعة أو تجاريةً.", color: "#27AE60" },
      { title: "الإهمال", text: "الفشل في توفير الحد الأدنى من الرعاية، سواء كانت جسدية أم عاطفية، مما يتسبب في إلحاق ضرر. ويتعلق هذا عادةً بالرعاية التي يقدمها الآباء أو مقدمو الرعاية للأطفال، أو المدربين تجاه الرياضيين.", color: "#F39C12" },
    ],
    readMore: "اقرأ المزيد",
    hide: "إخفاء",
  },
  reporting: {
    title: "الإبلاغ عن المخاوف",
    mainText: "يتحمل الجميع مسؤولية التأكد من عدم تعرض أي شخص لإساءة المعاملة أو التحرش أو الاستغلال. لذا، إن كان لدى أي شخص شكوك حول تعرض طفل أو بالغ لإساءة المعاملة أو التحرش أو الاستغلال بشكل ما أو بشأن سلوك شخص آخر، فيجب إبلاغ مسؤول حماية المؤسسة كي يتمكن من تقييم الأمر والتعامل معه بشكل لائق.",
    emergencyTitle: "تنبيه عاجل",
    emergencyNote: "إن كان شخص ما معرضًا لخطر الإصابة بضرر جسيم، فلا ينبغي أن يكون هناك تأخير في الإبلاغ عن الأمر إلى خدمات الطوارئ.",
    investigationNote: "يجب أن يضطلع بالتحقيق بشأن المخاوف والادعاءات شخص غير مرتبط بالمسألة بأي شكل من الأشكال. كلما ازدادت خطورة المخاوف أو الادعاءات وجسامتها، اشتدت ضرورة أن يكون الشخص الذي يحقق فيها منفصلاً عن المؤسسة.",
    flowchartTitle: "المخطط الانسيابي للإبلاغ",
    flowchartSubtitle: "مخطط انسيابي للإبلاغ عن مخاوف إساءة المعاملة والتحرش والاستغلال.\nهذا المخطط الانسيابي عام، ويجب قراءته وتصميمه لصالح المؤسسة عملاً بالتشريعات المحلية والتوجيهات الحكومية الخاصة بالإحالات المتعلقة بحماية الطفل.",
    steps: [
      { text: "ملاحظة مخاوف أو تلقي شكوى", type: "start" },
      { text: "إبلاغ مسؤول حماية المؤسسة فورًا", type: "action" },
      { text: "هل الشخص في خطر فوري؟", type: "decision" },
      { text: "الاتصال بخدمات الطوارئ فورًا", type: "urgent" },
      { text: "تقييم المخاوف من قبل مسؤول الحماية", type: "action" },
      { text: "التنسيق مع مسؤول حماية الاتحاد العضو", type: "action" },
      { text: "التحقيق واتخاذ الإجراءات المناسبة", type: "end" },
    ],
    formTitle: "نموذج الإبلاغ عن مخاوف",
    formName: "الاسم",
    formNamePlaceholder: "أدخل اسمك الكامل",
    formEmail: "البريد الإلكتروني",
    formEmailPlaceholder: "example@email.com",
    formMobile: "رقم الجوال",
    formMobilePlaceholder: "+970 59 123 4567",
    formOptional: "اختياري",
    formDescription: "وصف الحالة",
    formDescriptionPlaceholder: "اشرح ما تعرّض له الرياضي بالتفصيل...",
    formSubmit: "إرسال البلاغ",
    formSuccess: "تم الإرسال بنجاح",
    formSuccessMsg: "شكرًا لك، سيتم مراجعة بلاغك والتواصل معك في أقرب وقت.",
    formAnother: "إرسال بلاغ آخر",
  },
  meeting: {
    eyebrow: "حجز اجتماع",
    title: "اجتماع مع مسؤول الحماية",
    description: "هل تفضل محادثة فردية؟ اطلب اجتماعاً سرياً مع مسؤول حماية بشري — وسنتواصل معك لتحديد الموعد.",
    formName: "الاسم الكامل",
    formNamePlaceholder: "اسمك الكامل",
    formEmail: "البريد الإلكتروني",
    formEmailPlaceholder: "you@example.com",
    formReason: "سبب الاجتماع",
    formReasonPlaceholder: "صف باختصار ما تود مناقشته...",
    formDateTime: "التاريخ والوقت المفضّل",
    formDateTimeOptional: "اختياري",
    formSubmit: "طلب الاجتماع",
    formSubmitting: "جارٍ الإرسال...",
    formSuccess: "تم إرسال الطلب",
    formSuccessMsg: "شكراً لك. سيتواصل معك مسؤول الحماية قريباً لتحديد موعد اجتماعك.",
    formAnother: "إرسال طلب آخر",
    formError: "تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.",
  },
  conduct: {
    title: "مدوّنات قواعد السلوك",
    intro: "يجب أن يكون لدى المؤسسة مدوّنات قواعد سلوك لموظفيه ومسؤوليه التنفيذيين وأي أشخاص آخرين معنيين بإدارة المؤسسة.",
    description: "تتمحور مدوّنات قواعد السلوك كلها حول معاملة الآخرين باحترام ومساواة ونزاهة وبشكل يحفظ كرامتهم، وتستند إلى مبدأ أن لكل شخص قيمةً وأنه يستحق الاحترام.",
    codes: [
      { title: "مدوّنات المدربين", icon: "clipboard" },
      { title: "مدوّنات الرياضيين", icon: "trophy" },
      { title: "مدوّنات الآباء ومقدمي الرعاية", icon: "home" },
    ],
    violationNote: "إذا كان هناك شخص على علم بأن أي شخص آخر ينتهك مدوّنات قواعد السلوك ذات الصلة، فيجب إحالة ذلك الانتهاك إلى مسؤول الحماية باعتباره مصدرَ مخاوف للتحقيق فيه واتخاذ إجراءات تأديبية محتملة.",
  },
  additional: {
    readMore: "اقرأ المزيد",
    sections: [
      { id: "scope", title: "نطاق السياسة", text: "تنطبق هذه السياسة على المؤسسة ورياضييه وموظفيه وأي شخص آخر يرتبط بالمؤسسة. ويشمل ذلك المسؤولين والمتطوعين وأعضاء فرق العناية بالرياضيين والآباء ومقدمي الرعاية وأي شخص مرتبط بمجال الألعاب الرياضية في المؤسسة." },
      { id: "employment", title: "التوظيف", text: "سيُطلب من جميع المتقدمين لأي دور يتطلب العمل عن كثب مع الأطفال الخضوع إلى فحوصات خلفية أو فحوصات سجلاتهم الجنائية. وسيُطلب من جميع المتقدمين حضور مقابلة شخصية وتقديم مُرجعين، وحضور جلسةً تعريفيةً فور تعيينهم." },
      { id: "training", title: "التدريب والتعليم", text: "سيحصل جميع موظفي المؤسسة ومتطوعيه ومسؤوليه على تدريب في مجال الحماية ذي صلة بأدوارهم داخل المؤسسة. وسيحصل العاملون الذين يحتكون بالأطفال على تدريب تخصصي يتعلق تحديدًا بمسؤولياتهم تجاه الأطفال." },
    ],
    bottom: [
      { id: "disciplinary", title: "الإجراءات التأديبية", text: "سيتم التعامل مع انتهاكات هذه السياسة وقواعد حماية الاتحاد العضو بموجب الإجراءات التأديبية الخاصة بالمؤسسة أو الاتحاد العضو، ويجب الرجوع إليها للحصول على مزيد من الإرشادات." },
      { id: "review", title: "مراجعة هذه السياسة", text: "ستخضع هذه السياسة للمراجعة سنويًّا، ومرةً واحدةً على الأقل كل ثلاث سنوات بمعرفة كبار القادة ومسؤولي المؤسسة." },
      { id: "monitoring", title: "المراقبة", text: "ستتم مراقبة هذه السياسة وتنفيذها بانتظام على النحو اللائق بمعرفة المؤسسة أو بمعرفة سلطة حماية مستقلة تتمتع بالخبرة اللازمة للاضطلاع بهذه المهمة." },
    ],
  },
  safeguardingOfficer: {
    title: "مسؤول الحماية",
    intro: "يجب أن يكون لدى كل مؤسسة واتحاد عضو مسؤول حماية معيّن مسؤول عن تنفيذ سياسة الحماية. وهو نقطة الاتصال الأولى لأي مخاوف.",
    description: "قد يحمل مسؤول الحماية أدواراً أخرى داخل المؤسسة — المهم أن تكون المسؤولية موكلة بوضوح وأن يعرف الجميع إلى من يتوجهون. وهو يعمل عن كثب مع الإدارة العليا والجهات المحلية والمحققين الخارجيين عند الضرورة.",
    responsibilitiesTitle: "المسؤوليات الرئيسية",
    responsibilities: [
      "تلقي وتسجيل المخاوف المبلَّغ عنها للمؤسسة أو الاتحاد.",
      "طلب أي معلومات إضافية لازمة لإدارة الحالة.",
      "الالتزام بالتشريعات المحلية ومتطلبات الإبلاغ الإلزامي.",
      "تقديم تقارير منتظمة للإدارة العليا حول أعداد المخاوف وفئاتها ونتائجها.",
      "تقديم تقرير حماية سنوي إلى مجلس الإدارة.",
      "تحديد ما إذا كان ينبغي إحالة الأمر إلى الشرطة أو الخدمات الاجتماعية أو الجهات الخارجية.",
      "تقديم الدعم والإرشاد لجميع المعنيين بالحالة.",
      "إجراء التحقيقات في المخاوف منخفضة المستوى وحالات الممارسة السيئة.",
      "التنسيق مع الإجراءات التأديبية وتقديم الدعم خلالها.",
      "فهم قوانين السرية ومتطلبات الموافقة.",
      "تدريب الموظفين والمسؤولين والمتطوعين والرياضيين والآباء لرفع الوعي بالحماية.",
    ],
  },
  riskAreas: {
    title: "مجالات الخطر الكبيرة",
    intro: "تنطوي ألعاب القوى على سياقات متعددة قد تنشأ فيها مخاطر الحماية. يجب على المؤسسات تقديم توجيهات صريحة لما هو متوقع من الموظفين والمدربين والرياضيين والمتطوعين في كل من هذه الحالات.",
    items: [
      { title: "اللقاءات الفردية", text: "يجب التخطيط للقاءات بين البالغين والأطفال مسبقاً، وأن تتم في أماكن مرئية، وأن يتم إبلاغ طرف ثالث بها قدر الإمكان.", icon: "users" },
      { title: "جلسات التدريب", text: "يجب أن تتبع جلسات التدريب الفردية بروتوكولات المؤسسة. ينبغي أن يتجنب المدربون البقاء بمفردهم مع رياضي واحد في بيئات مغلقة.", icon: "dumbbell" },
      { title: "التصوير والتسجيل", text: "يجب الحصول على موافقة قبل تصوير الرياضيين أو تسجيلهم. لا يجوز استخدام الأجهزة في غرف تغيير الملابس أو السياقات الحساسة.", icon: "camera" },
      { title: "السفر", text: "عند السفر مع الرياضيين الصغار، يجب وضع بروتوكولات للإقامة والإشراف والتواصل. ويجب إبلاغ الآباء باستمرار.", icon: "plane" },
      { title: "وسائل التواصل والإنترنت", text: "يجب أن تتم الاتصالات بين المدربين والرياضيين عبر القنوات الرسمية. ويجب الإبلاغ عن التنمر الإلكتروني والسلوك غير اللائق عبر الإنترنت.", icon: "smartphone" },
      { title: "غرف تغيير الملابس", text: "لا ينبغي أن يكون البالغون بمفردهم مع الأطفال في غرف تغيير الملابس. وحيث يلزم الإشراف، يجب وجود اثنين من البالغين على الأقل.", icon: "door-open" },
      { title: "التدليك والعلاج الطبيعي", text: "يجب أن يقوم بالعلاج الطبيعي مختصون مؤهلون فقط، بموافقة الرياضي، وبحضور مرافق عند الاقتضاء.", icon: "hand" },
      { title: "السلوك بين الأقران", text: "يجب التعامل مع التنمر والمضايقة والتحرش بين الأقران — الرياضيين أو المدربين أو المسؤولين — بنفس الجدية مثل أي مخاوف حماية أخرى.", icon: "user-x" },
    ],
  },
  recruitment: {
    title: "التوظيف الآمن والتدريب",
    intro: "إن الأشخاص الذين يعملون ويتطوعون في ألعاب القوى هم الجانب الأهم في الحماية. توظيف الأشخاص المناسبين — وتدريبهم جيداً — أمر بالغ الأهمية لترسيخ حماية عالية الجودة في كل مؤسسة.",
    principlesTitle: "مبادئ التوظيف الآمن",
    principles: [
      { title: "أوصاف وظيفية واضحة", text: "يجب أن يكون لكل دور وصف مكتوب يحدد المسؤوليات والمؤهلات المطلوبة وبيان واضح بأن الحماية مسؤولية الجميع.", icon: "file-text" },
      { title: "إعلان شفاف", text: "يجب الإعلان عن الوظائف الشاغرة — سواء كانت بأجر أو تطوعية — بشكل علني، مع ذكر توقعات الحماية وأي فحوصات خلفية مطلوبة منذ البداية.", icon: "megaphone" },
      { title: "مقابلات قائمة على القيم", text: "أجرِ مقابلة مع كل مرشح في القائمة المختصرة واطرح أسئلة قائمة على القيم: تجاربه السابقة، فهمه للحماية، وكيف سيتعامل مع المخاوف.", icon: "message-square" },
      { title: "فحوصات الخلفية", text: "يجب إجراء فحوصات السجل الجنائي والخلفية لأي دور يعمل مع الأطفال، مع استلام النتائج قبل تاريخ بدء العمل.", icon: "search" },
      { title: "مراجع موثوقة", text: "احصل دائماً على مرجعين على الأقل وتحقق منهما — اتصل بالمرجع أو تواصل معه مباشرةً. اسأل تحديداً عن أي مخاوف حماية سابقة.", icon: "phone" },
      { title: "التعريف والتدريب", text: "يتلقى كل موظف جديد تدريباً على الحماية كجزء من جلسة التعريف. يتم تجديد التدريب بانتظام لجميع الموظفين والمتطوعين والرياضيين والمسؤولين.", icon: "graduation-cap" },
    ],
    trainingTitle: "التدريب والتعليم",
    trainingText: "يجب أن يكون تدريب الحماية ذا صلة بكل دور. ويتلقى من يعملون مباشرةً مع الأطفال تدريباً متخصصاً. يجب الاحتفاظ بسجلات جميع التدريبات وتجديدها مرة كل عامين على الأقل. تتوفر الموارد عبر منصة الرياضة الآمنة للجنة الأولمبية الدولية، والاتحاد الدولي لألعاب القوى، والاتحادات الوطنية.",
  },
  reportingExtra: {
    mandatoryTitle: "الإبلاغ الإلزامي",
    mandatoryText: "تشترط بعض الدول قانوناً الإبلاغ عن شكوك إساءة معاملة الأطفال إلى السلطات العامة. يجب على المؤسسات البحث في متطلبات الإبلاغ الإلزامي المطبقة في إقليمها وتوضيحها. ليس من دور المُبلِّغ تحديد ما إذا كانت الإساءة قد حدثت — بل فقط نقل المخاوف إلى المؤهلين لتقييمها.",
    whoReportsTitle: "قد تأتي البلاغات من",
    whoReports: [
      "ضحية تكشف عن الإساءة مباشرةً.",
      "شاهد لاحظ الحادث.",
      "أي شخص يلاحظ مؤشرات إساءة على مدى فترة — حتى لو وقع الحادث خارج ألعاب القوى.",
    ],
  },
  downloads: {
    title: "الموارد والتنزيلات",
    intro: "اطّلع على وثائق الحماية الرسمية والنماذج وقم بتنزيلها. حمّل هذه الموارد واقرأها وشاركها مع موظفي مؤسستك ومدربيك ورياضييك ومتطوعيك.",
    download: "تنزيل",
    fileType: "وثيقة",
    docs: {
      intro: {
        title: "مقدمة في مواد الحماية",
        desc: "نظرة عامة على إطار الحماية والمواد المتاحة للاتحادات الأعضاء لبدء رحلتهم في مجال الحماية.",
      },
      starter: {
        title: "حزمة الانطلاق للحماية",
        desc: "حزمة بداية عملية للاتحادات الأعضاء لإنشاء منظومة الحماية من الصفر — تشمل نماذج السياسة وقواعد السلوك واللوائح.",
      },
      guide: {
        title: "دليل الحماية",
        desc: "الدليل الكامل للاتحاد العضو يغطي التقييم وكتابة السياسة والتوظيف والتدريب والتحقيقات والشراكات والمراقبة.",
      },
      flowchart: {
        title: "مخطط انسيابي للسياسة",
        desc: "مخطط انسيابي مرئي يصف كل خطوة من خطوات إنتاج واعتماد سياسة الحماية داخل مؤسستك.",
      },
      actionPlan: {
        title: "خطة العمل",
        desc: "قالب خطة عمل جاهز للاستخدام لتقييم وضعك الحالي في مجال الحماية والتخطيط للخطوات القادمة.",
      },
      policy: {
        title: "سياسة الحماية للاتحاد الدولي لألعاب القوى",
        desc: "سياسة الحماية الرسمية للاتحاد الدولي لألعاب القوى — الوثيقة المرجعية العالمية التي تستند إليها جميع سياسات الاتحادات الوطنية والمؤسسات.",
      },
      rules: {
        title: "قواعد الحماية (D1.2)",
        desc: "قواعد الحماية الرسمية التي تغطي السلوك المحظور والتحقيقات والعقوبات والاستئنافات وآلية إدارة الحالات.",
      },
      reportingGuidance: {
        title: "إرشادات الإبلاغ عن مسائل الحماية",
        desc: "إرشادات للاتحادات الأعضاء والروابط الإقليمية حول كيفية الإبلاغ عن مسائل الحماية إلى الاتحاد الدولي لألعاب القوى.",
      },
      template: {
        title: "نموذج سياسة الحماية للاتحاد العضو",
        desc: "نموذج سياسة حماية جاهز للتكييف للاتحادات الأعضاء — متوفر بـ 19 لغة، منها الإنجليزية والعربية والإسبانية والفرنسية والإيطالية والبرتغالية والهولندية والبولندية والروسية والصينية والهندية والأردية والكورية واليابانية والإندونيسية والفيتنامية والفلبينية والأورومو والكوكبوروك.",
      },
    },
  },
  aiAgent: {
    eyebrow: "المساعد الذكي",
    title: "تعرّف على خبير الحماية الذكي",
    description: "أجرِ محادثة حية ووجهاً لوجه مع وكيلنا الذكي. اسأل عن أي شيء يخص سياسة الحماية — التعريفات، خطوات الإبلاغ، قواعد السلوك، متطلبات التدريب — واحصل على إجابات فورية ودقيقة بلغتك.",
    liveLabel: "مباشر",
    features: [
      "متاح على مدار الساعة — احصل على المساعدة في أي وقت.",
      "يتحدث باللغة التي تختارها على الموقع.",
      "مقتصر تماماً على موضوع الحماية — إجابات دقيقة وذات صلة.",
      "تحدث صوتياً أو اكتب — كما يناسبك.",
    ],
  },
  footer: {
    description: "نموذج سياسة الحماية لألعاب القوى - ضمان بيئة آمنة وإيجابية لجميع المشاركين.",
    quickLinks: "روابط سريعة",
    policyContents: "محتويات السياسة",
    copyright: "© 2025 سياسة الحماية للمؤسسات الرياضية. جميع الحقوق محفوظة.",
    backToTop: "العودة إلى الأعلى",
  },
  chat: {
    title: "مساعد الحماية الذكي",
    subtitle: "متخصص في سياسة الحماية الرياضية",
    welcome: "مرحبًا! أنا مساعدك الذكي المتخصص في سياسة الحماية للمؤسسات الرياضية. كيف يمكنني مساعدتك؟",
    placeholder: "اكتب سؤالك هنا...",
    error: "عذرًا، حدث خطأ. يرجى المحاولة مرة أخرى.",
    meetAgent: "تعرّف على خبيرنا الذكي المرئي",
    reportConcern: "الإبلاغ عن مخاوف",
  },
};
